import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  open: false,
  message: '',
  severity: 'success'
}

const RootSnackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    handleSnackbarOpen: (state, action) => {
      state.open = true
      state.message = action.payload?.message
      state.severity = action.payload?.type || 'success'
    },
    handleSnackbarClose: (state) => {
      state.open = false
    },
    handleSeverity: (state, action) => {
      state.severity = action.payload
    }
  }
})

export const { handleSnackbarOpen, handleSnackbarClose, handleSeverity } = RootSnackbarSlice.actions

export default RootSnackbarSlice.reducer